const CHECK_INTERVAL = 60 * 1000; // check every 60s

export function register() {
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', async () => {
    try {
      const reg = await navigator.serviceWorker.register('/service-worker.js');

      // Listen for update found
      reg.addEventListener('updatefound', () => {
        const newWorker = reg.installing;
        if (!newWorker) return;
        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'activated' && navigator.serviceWorker.controller) {
            // New version activated while user was on the page — reload
            window.location.reload();
          }
        });
      });

      // Periodic update check
      setInterval(() => { reg.update(); }, CHECK_INTERVAL);

      // Listen for SW_UPDATED message from service worker
      navigator.serviceWorker.addEventListener('message', (event) => {
        if (event.data?.type === 'SW_UPDATED') {
          window.location.reload();
        }
      });
    } catch (err) {
      console.warn('SW registration failed:', err);
    }
  });
}
